export function renderChart(ctx, shape, ptScale) {
    const x = shape.position.x * ptScale;
    const y = shape.position.y * ptScale;
    const width = shape.size.width * ptScale;
    const height = shape.size.height * ptScale;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(x, y, width, height);
    ctx.strokeStyle = '#cccccc';
    ctx.lineWidth = 1;
    ctx.strokeRect(x, y, width, height);
    const padding = 20 * ptScale;
    const chartX = x + padding;
    const chartY = y + padding;
    const chartWidth = width - padding * 2;
    const chartHeight = height - padding * 2;
    const barWidth = chartWidth / 4;
    const barHeights = [0.6, 0.8, 0.5];
    ctx.fillStyle = '#4472C4';
    barHeights.forEach((heightRatio, i) => {
        const barHeight = chartHeight * heightRatio;
        const barX = chartX + i * barWidth + barWidth * 0.2;
        const barY = chartY + chartHeight - barHeight;
        ctx.fillRect(barX, barY, barWidth * 0.6, barHeight);
    });
    ctx.fillStyle = '#666666';
    ctx.font = `${12 * ptScale}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    ctx.fillText('Chart', x + width / 2, y + height - 5 * ptScale);
}
//# sourceMappingURL=chart.js.map